var map = {
	"account/account.module": [
		"./src/account/account.module.ts",
		"account-account-module"
	],
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"app-admin-admin-module"
	],
	"app/main/main.module": [
		"./src/app/main/main.module.ts",
		"common",
		"app-main-main-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;